import { computed } from 'vue';
import { useRoute } from '@/use/use-reactive-route';

export const useRouteExtensions = () => {
  const route = useRoute();

  const aanbodNaam = computed(() => {
    return route.currentRoute?.value?.params?.aanbod ?? route.currentRoute?.value?.query?.aanbod;
  });

  const aanvraagId = computed(() => route.currentRoute?.value?.query?.aanvraagId);

  const lang = computed(
    () =>
      route.currentRoute?.value.meta?.lang ??
      route.currentRoute?.value.params?.lang ??
      route.currentRoute?.value.query?.lang
  );

  const pageNaam = computed(() => {
    return (
      route.currentRoute?.value?.params?.page ??
      //BACK-COMPAT
      route.currentRoute?.value?.params?.stap
    );
  });

  const subflowNaam = computed(() => {
    return route.currentRoute?.value?.params?.subflow || route.currentRoute?.value?.query?.subflow;
  });

  return {
    ...route,
    lang,
    aanbodNaam,
    aanvraagId,
    pageNaam,
    subflowNaam
  };
};
